import React from "react";
import Dispatcher from "../../dispatcher";
import LibraryStore from "../../stores/library-store";

var Menu = require("../ui_elements/menu").Menu;
var MenuMixin = require("../ui_elements/menu").MenuMixin;
var Isvg = require("../../../vendor/react-inlinesvg");
var MenuList = require("../ui_elements/menu-list");
var numeral = require("numeral");
var CitationsMixin = require("../resources/citations").CitationsMixin;
var Tooltip = require("../ui_elements/tooltip").Tooltip;
var TooltipMixin = require("../ui_elements/tooltip").TooltipMixin;
import Truncate from "../ui_elements/truncate";
import EditContainer from "../layouts/edit-container";
var moment = require("moment");
var AccessCodeModal = require("../gadgets/src/online-resources/access-code-modal");

import ResourcesTable from "./resources-table";
/*
  Renders an individual book view within a book list
    props: cover, title, author, ...
*/
class BookContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coverHolderHeight: this.props.coverHolderHeight || 0,
      listViewCardHeight: this.props.listViewCardHeight || 0,
      listViewSecondaryHeight: this.props.listViewSecondaryHeight || 0,
      tooltip: this.props.tooltip || "",
      highlightCount: this.props.badgeData.highlights
        ? this.props.badgeData.highlights.highlightCount +
          this.props.badgeData.highlights.subscriptions.highlightCount
        : 0,
      noteCount: this.props.badgeData.highlights
        ? this.props.badgeData.highlights.noteCount +
          this.props.badgeData.highlights.subscriptions.noteCount
        : 0
    };

    // TooltipMixin bindings
    this.showTooltip = TooltipMixin.showTooltip.bind(this);
    this.removeTooltip = TooltipMixin.removeTooltip.bind(this);
    this._addTooltipEvent = TooltipMixin._addTooltipEvent.bind(this);
    this._removeTooltipEvent = TooltipMixin._removeTooltipEvent.bind(this);

    // MenuMixin bindings
    this._toggleMenu = MenuMixin._toggleMenu.bind(this);
    this._showMenu = MenuMixin._showMenu.bind(this);
    this._removeMenu = MenuMixin._removeMenu.bind(this);
    this._redrawMenu = MenuMixin._redrawMenu.bind(this);

    // Bind all methods that use `this`
    this._updateCover = this._updateCover.bind(this);
    this._flipToFront = this._flipToFront.bind(this);
    this._clickBook = this._clickBook.bind(this);
    this._clickCitations = this._clickCitations.bind(this);
    this._checkListViewCardHeight = this._checkListViewCardHeight.bind(this);
    this._clickCopyURL = this._clickCopyURL.bind(this);
    this.toggleBookFlipState = this.toggleBookFlipState.bind(this);
    this._hideSlideout = this._hideSlideout.bind(this);
    this._showSlideout = this._showSlideout.bind(this);
    this._toggleSlideout = this._toggleSlideout.bind(this);
    this.renderSlideout = this.renderSlideout.bind(this);
    this._openAssignment = this._openAssignment.bind(this);
    this._deleteAssignment = this._deleteAssignment.bind(this);
    this._goToCourseware = this._goToCourseware.bind(this);
    this._revealAccessCode = this._revealAccessCode.bind(this);
    this.renderBadge = this.renderBadge.bind(this);
    this.renderMobileOptionsMenu = this.renderMobileOptionsMenu.bind(this);
    this.renderGridBadges = this.renderGridBadges.bind(this);
    this.renderListBadges = this.renderListBadges.bind(this);
    this.renderDropdownListItem = this.renderDropdownListItem.bind(this);
    this.renderNoteListItem = this.renderNoteListItem.bind(this);
    this.renderFlashCardListItem = this.renderFlashCardListItem.bind(this);
    this.renderExpirationDate = this.renderExpirationDate.bind(this);
    this.renderHighlightsListItem = this.renderHighlightsListItem.bind(this);
    this.renderCopyLink = this.renderCopyLink.bind(this);
    this.renderBookInfo = this.renderBookInfo.bind(this);
    this.renderSlideoutContent = this.renderSlideoutContent.bind(this);
    this.renderCard = this.renderCard.bind(this);
    this.renderBookBack = this.renderBookBack.bind(this);
    this.renderBookFront = this.renderBookFront.bind(this);
    this.renderLoaderCard = this.renderLoaderCard.bind(this);

    // Refs
    this.cardRefRef = React.createRef();
    this.coverHolderRef = React.createRef();
    this.coverImageRef = React.createRef();
    this.primarycontRef = React.createRef();
    this.titleRef = React.createRef();
    this.authorRef = React.createRef();
  }

  componentDidMount() {
    Dispatcher.bind(Dispatcher.LIBRARY_HIDE_SLIDEOUT, this._hideSlideout);

    this._updateCover();
    this._checkListViewCardHeight();
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.LIBRARY_HIDE_SLIDEOUT, this._hideSlideout);
    clearTimeout(this.hideSlideoutTimeout);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.view !== prevProps.view ||
      this.props.window.width !== prevProps.window.width ||
      // if the number of container
      this.props.containerViewClass !== prevProps.containerViewClass
    ) {
      $(this.titleRef.current).trigger("update");
      $(this.authorRef.current).trigger("update");
      this._updateCover();
      this._hideSlideout();
      this._flipToFront();
      this._checkListViewCardHeight();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const highlights = nextProps.badgeData.highlights;
    if (highlights) {
      const highlightCount = highlights.highlightCount;
      const subscriptionsCount = highlights.subscriptions.highlightCount;
      const noteCount = highlights.noteCount;
      const subscriptionsNoteCount = highlights.subscriptions.noteCount;
      this.setState({
        highlightCount: highlightCount + subscriptionsCount,
        noteCount: noteCount + subscriptionsNoteCount
      });
    } else {
      this.setState({ highlightCount: 0, noteCount: 0 });
    }
  }

  _updateCover(isbn = this.props.isbn) {
    // Had to add this because clientWidth was breaking page sometimes! How to fix properly?
    var coverHolder = this.coverHolderRef.current;
    if (coverHolder) {
      this.setState({ coverHolderHeight: coverHolder.clientWidth * 1.3 });
    }
  }

  _flipToFront(isbn) {
    if (this.props.isbn !== isbn && this.state.isFlipped) {
      this.toggleBookFlipState();
    }
  }

  _clickBook(e) {
    Fraction.Reporter.gaEvent("V3/books", this.props.isbn, "openBook");
  }

  _clickCitations(e) {
    CitationsMixin._citations(this.props);
  }

  _checkListViewCardHeight() {
    var primaryContainerHeight = $(this.primarycontRef.current).height();
    /* 76 is the max pixel height when a library list view card has 1 line of the
       book title, author and edition. */
    if (primaryContainerHeight > 76) {
      this.setState({ listViewCardHeight: 140, listViewSecondaryHeight: 101 });
    } else {
      this.setState({ listViewCardHeight: "", listViewSecondaryHeight: "" });
    }
    /* listViewSecondaryHeight is being changed to draw the divider line longer
       when library list view card has more than 1 line of the book title */
  }

  _clickCopyURL(e) {
    var link =
      document.location.protocol +
      "//" +
      document.location.host +
      "/#/books/" +
      this.props.isbn;
    Fraction.Helpers.Reader.copyURL(link);
  }

  toggleBookFlipState() {
    this.setState({ isFlipping: true });
    setTimeout(() => {
      this.setState((state, props) => {
        return {
          isFlipping: false,
          isFlipped: !state.isFlipped
        };
      });
    }, 250);
  }

  _hideSlideout(isbn) {
    if (isbn === this.props.isbn) {
      return;
    }
    this.setState({ slideOutWidth: 0, slideoutPadding: 0, slidingDown: true });
    clearTimeout(this.hideSlideoutTimeout);
    this.hideSlideoutTimeout = setTimeout(() => {
      this.setState({
        viewingSlideout: false,
        slideoutView: false,
        slideoutPadding: false,
        slidingDown: false
      });
    }, 250);
  }

  _showSlideout(isbn) {
    // Rename keys in en.json so we dont need this ternary operator and change code below to reflect new keys. Double check if keys are already used.
    if (isbn === this.props.isbn) {
      return;
    }
    if (Fraction.Helpers.isSmallScreen()) {
      Fraction.Helpers.showModal({
        fullscreen: true,
        content: (
          <EditContainer
            cancelEditCallback={Fraction.Helpers.removeModal}
            title={i18n.t("library." + this.state.slideoutView)}
          >
            {this.renderSlideoutContent()}
          </EditContainer>
        )
      });
    } else {
      const cardPosition = $(this.cardRefRef.current).position();
      const width = $(this.cardRefRef.current).outerWidth();
      const height = $(this.cardRefRef.current).outerHeight();
      Dispatcher.emit(Dispatcher.LIBRARY_HIDE_SLIDEOUT, this.props.isbn);
      this.setState(
        {
          viewingSlideout: true,
          slidingDown: true
        },
        () => {
          this.setState({
            slideOutWidth:
              $(window).width() - this.cardRefRef.current.clientWidth - 18,
            slidingDown: false
          });
        }
      );
    }
  }

  _toggleSlideout(view) {
    if (this.state.viewingSlideout) {
      this._hideSlideout();
      if (view && view.length > 0 && this.state.slideoutView !== view) {
        setTimeout(() => {
          this._toggleSlideout(view);
        }, 251);
      }
    } else {
      this.setState(
        {
          slideoutView: view
        },
        this._showSlideout
      );
    }
    this._removeMenu();
  }

  renderSlideout(children) {
    // TODO probably pull this into it's own lil jsx file that takes children;
    if (this.props.view === "grid") {
      let contentOpen = null;
      if (this.props.isCollectionsOpen) {
        contentOpen = $(".grid").width() - $(".card-content").innerWidth() - 12;
      }
      return (
        <div
          id="slideout-box"
          style={{
            left: this.cardRefRef.current.offsetWidth + 6,
            height: this.cardRefRef.current.offsetHeight,
            width: contentOpen || this.state.slideOutWidth,
            padding: this.state.slideoutPadding
          }}
        >
          {children}
        </div>
      );
    } else {
      let style = {};
      if (this.state.slidingDown) {
        style = { height: 0, padding: 0 };
      }
      return (
        <div id="slidedown-box" style={style}>
          {children}
        </div>
      );
    }
  }

  _openAssignment(uuid) {
    window.location = `${window.location.origin}/#/books/${this.props.isbn}/assignment/${uuid}`;
  }

  _deleteAssignment(e, uuid) {
    e.stopPropagation();
    this.props.deleteAssignment(uuid, () => {
      this.forceUpdate();
    });
  }

  _goToCourseware(url) {
    Fraction.Helpers.Locations.safeRedirect(url, "_blank");
  }

  _revealAccessCode() {
    Fraction.Helpers.showModal({
      title: `${i18n.t(
        "eresources.courseware"
      )}: ${this.props.title.decodeHTML()}`,
      content: <AccessCodeModal isbn={this.props.isbn} />,
      closeCallback: function () {},
      className: "courseware-modal",
      definingClass: "courseware-modal",
      buttons: [],
      width: 500
    });
  }

  renderBadge(id, label, icon, onClick) {
    return (
      <li
        className={`badge ${id}`}
        data-tooltip={label}
        data-tooltip-location="top"
        data-tooltip-top="-24"
        onMouseEnter={this._addTooltipEvent}
        onMouseLeave={this._removeTooltipEvent}
      >
        <button className="noButton" onClick={onClick}>
          <Isvg
            key={`${this.props.isbn}.badge.icon.li.svg.${icon}`}
            src={icon}
          />
          <span className="screenHidden">{label}</span>
        </button>
      </li>
    );
  }

  renderMobileOptionsMenu() {
    if (Fraction.Helpers.isSmallScreen()) {
      let image = null;
      let mobileMargin = "";
      if (this.props.view === "list") {
        image = <Isvg src="/img/3-dot_menu.svg" />;
        mobileMargin = "mobile-menu-margins ";
      }
      return (
        <button
          onClick={this._toggleMenu}
          className={`${mobileMargin} more-menu noButton cover-button`}
          data-menu-id={"book-info-dropdown" + this.props.isbn}
          aria-hidden={true}
        >
          {image}
        </button>
      );
    }
  }

  renderGridBadges() {
    return (
      <div className="badging-container">
        <ul className="badging-list-container">
          {this.state.highlightCount > 0 &&
            this.renderBadge(
              "book-highlights",
              `${this.state.highlightCount} ${
                this.state.highlightCount === 1
                  ? i18n.t("filter.highlight")
                  : i18n.t("filter.highlights")
              }`,
              "../img/highlights.svg"
            )}
          {this.state.noteCount > 0 &&
            this.renderBadge(
              "book-notes",
              `${this.state.noteCount} ${
                this.state.noteCount === 1
                  ? i18n.t("filter.note")
                  : i18n.t("filter.notes")
              }`,
              "../img/notes.svg"
            )}
          {this.props.badgeData.ancillaries &&
            this.renderBadge(
              "book-resources",
              this.props.badgeData.ancillaries.ancillariesCount +
                this.props.badgeData.ancillaries.accessCodeCount +
                " " +
                (this.props.badgeData.ancillaries.ancillariesCount > 1
                  ? i18n.t("filter.resources")
                  : i18n.t("filter.resource")),
              this.state.slideoutView === "resources" &&
                !Fraction.Helpers.isSmallScreen()
                ? "../img/badge_resources_selected.svg"
                : "../img/resources2.svg",
              e => {
                e.stopPropagation();
                this._toggleSlideout("resources");
              }
            )}
          {this.props.badgeData.flashCardDecks.length > 0 &&
            this.renderBadge(
              "book-flashcards",
              `${this.props.badgeData.flashCardDecks.length} ${i18n.pluralize(
                this.props.badgeData.flashCardDecks.length,
                "library.flashcard-badge",
                "library.flashcards-badge"
              )}`,
              "../img/flashcards_front_badge.svg"
            )}
          <li className="book-flip-button">
            <button className="noButton" onClick={this.toggleBookFlipState}>
              <Isvg src="/img/3-dot_menu.svg" />
              <span className="screenHidden">
                {i18n.t("library.book.flip-book-card")}
              </span>
            </button>
          </li>
        </ul>
        {this.renderMobileOptionsMenu()}
        <Tooltip absolute tooltip={this.state.tooltip} />
      </div>
    );
  }

  renderListBadges() {
    return (
      <div className="list-badging-container">
        <ul className="list-badging-list">
          {this.renderExpirationDate()}
          {this.renderHighlightsListItem()}
          {this.renderNoteListItem()}
          {this.renderDropdownListItem(
            "resources",
            this.props.badgeData.ancillaries
              ? this.props.badgeData.ancillaries.ancillariesCount
              : 0,
            "/img/resources_icon.svg",
            () => {
              this._toggleSlideout("resources");
            }
          )}
          <li>
            <button className="noButton copy-link" onClick={this._clickCopyURL}>
              <Isvg src="/img/copy_link_small.svg" />
              <span>{i18n.t("library.copy-link")}</span>
            </button>
          </li>
        </ul>
        <Tooltip absolute tooltip={this.state.tooltip} />
      </div>
    );
  }

  renderDropdownListItem(id, count, icon, action) {
    if (count > 0) {
      const expanded =
        this.state.viewingSlideout && this.state.slideoutView === id;
      return (
        <li className="dropdown">
          <button
            className={`noButton ${expanded ? "expanded" : ""}`}
            aria-expanded={expanded}
            onClick={e => {
              e.preventDefault();
              action();
            }}
          >
            <Isvg src={icon} />
            {count}
            <Isvg className="arrow" src="/img/down_arrow.svg" />
          </button>
        </li>
      );
    } else {
      return;
    }
  }

  renderNoteListItem() {
    if (this.state.noteCount) {
      return (
        <li>
          <Isvg src="/img/notes_icon.svg" />
          {this.state.noteCount}
        </li>
      );
    } else {
      return;
    }
  }

  renderFlashCardListItem() {
    if (this.props.badgeData.flashCardDecks.length > 0) {
      return (
        <li>
          <Isvg src="/img/flashcards_back_badge.svg" />
          {this.props.badgeData.flashCardDecks.length}
        </li>
      );
    } else {
      return;
    }
  }

  renderExpirationDate() {
    // Expiration doesn't work yet
    // return (<li className="list-info-clock"><Isvg src={"/img/expiring_red.svg"} /> {moment(this.props.expiresAt).format('MM/DD/YYYY')}</li>);
  }

  renderHighlightsListItem() {
    if (this.state.highlightCount > 0) {
      return (
        <li>
          <Isvg src="/img/highlights_icon.svg" />
          {this.state.highlightCount}
        </li>
      );
    } else {
      return;
    }
  }

  renderCopyLink() {
    var link =
      document.location.protocol +
      "//" +
      document.location.host +
      "/#/books/" +
      this.props.isbn;
    return (
      <div className="mobile-book-info">
        <h3 id="mobile-url" className="slideout-number">
          {link}
        </h3>
        <button
          id="mobile-copy-btn"
          className="submit blue"
          onClick={() => {
            Fraction.Helpers.copyText(
              link,
              setTimeout(function () {
                Fraction.Helpers.toast(i18n.t("citations.page-url-copied"));
                Fraction.Helpers.removeModal();
              }, 500)
            );
          }}
        >
          Copy Url
        </button>
      </div>
    );
  }

  renderBookInfo() {
    let noteCount =
      this.props.badgeData.highlights &&
      this.props.badgeData.highlights.noteCount
        ? this.props.badgeData.highlights.noteCount
        : 0;
    let highlightCount =
      this.props.badgeData.highlights &&
      this.props.badgeData.highlights.highlightCount
        ? this.props.badgeData.highlights.highlightCount
        : 0;
    return (
      <div className="mobile-book-info">
        <div className="slideout-title">{this.props.title.decodeHTML()}</div>
        <div className="slideout-author">{this.props.author}</div>
        <div className="slideout-isbn">ISBN: {this.props.isbn}</div>
        <div className="highlight-note-count">
          <div className="mobile-highlight-count">
            <Isvg
              className="mobile-info-icon"
              src={"/img/highlights_icon.svg"}
            />
            {highlightCount === 1
              ? i18n.t("library.slideout.highlight-amount")
              : i18n.t("library.slideout.highlights-amount", {
                  amount: highlightCount
                })}
          </div>
          <div className="mobile-note-count">
            <Isvg className="mobile-info-icon" src={"/img/notes_icon.svg"} />
            {noteCount === 1
              ? i18n.t("library.slideout.note-amount")
              : i18n.t("library.slideout.notes-amount", { amount: noteCount })}
          </div>
        </div>
      </div>
    );
  }

  renderSlideoutContent() {
    if (this.state.slideoutView === "resources") {
      return (
        <ResourcesTable
          badgeData={this.props.badgeData}
          _toggleSlideout={this._toggleSlideout}
          isbn={this.props.isbn}
        />
      );
    } else if (this.state.slideoutView === "copy-link") {
      return this.renderCopyLink();
    } else if (this.state.slideoutView === "book-information") {
      return this.renderBookInfo();
    }
  }

  renderCard(children, side) {
    let cardHeight = false;
    if (this.state.isFlipped) {
      cardHeight =
        $(this.cardRefRef.current).outerHeight() ||
        $(".backSize").outerHeight() ||
        $(".card").outerHeight();
    }
    const styles = {
      minHeight: this.state.listViewCardHeight,
      height: cardHeight
    };
    if (this.state.viewingSlideout) {
      if (this.props.isCollectionsOpen && this.state.slideOutWidth > 0) {
        styles.transform = `translateX(-${
          this.cardRefRef.current.offsetLeft - 30 - $(".menuHeaderContainer").width()
        }px)`;
      } else if (this.state.slideOutWidth > 0) {
        styles.transform = `translateX(-${this.cardRefRef.current.offsetLeft - 6}px)`;
      }
      styles.zIndex = this.props.zindex || 2;
    }

    return (
      <li
        id={
          "library-card-" +
          this.props.isbn +
          "-" +
          this.props.index +
          "-" +
          this.props.openAssignmentCreator
        }
        className={`card ${side}`}
        style={styles}
        ref={this.cardRefRef}
      >
        <div
          className={`card-content ${
            this.state.isFlipping ? "isFlipping" : ""
          }`}
        >
          {children}
        </div>
        {this.state.viewingSlideout &&
          this.renderSlideout(this.renderSlideoutContent())}
      </li>
    );
  }

  renderBookBack() {
    const cardHeight =
      $(this.cardRefRef.current).outerHeight() ||
      $(".backSize").outerHeight() ||
      $(".card").outerHeight();
    const author =
      this.props.author && this.props.author !== " " ? (
        <div className="book-author">{`${i18n.t("library.author")}: ${
          this.props.author
        }`}</div>
      ) : null;
    const hasAccessCode = this.props.hasAccessCode;
    const license = LibraryStore.getAccessCode(this.props.isbn);
    const ancillaries = license && license.ancillaries;
    const accessCode = ancillaries && ancillaries.slice(-1).pop();

    const cardTemplate = (
      <span>
        {hasAccessCode && (
          <div className="courseware-header">
            {i18n.t("eresources.courseware")}
          </div>
        )}

        <div
          className={hasAccessCode ? "book-info with-ancillaries" : "book-info"}
        >
          <div
            className="book-title"
            title={this.props.title.decodeHTML()}
            ref={this.titleRef}
          >
            <Truncate>{this.props.title.decodeHTML()}</Truncate>
          </div>
          {author}

          <div className="book-isbn">ISBN: {this.props.isbn}</div>

          {hasAccessCode && accessCode && accessCode.href && (
            <div className="book-url">
              URL:{" "}
              <span onClick={() => this._goToCourseware(accessCode.href)}>
                {accessCode.href}
              </span>
            </div>
          )}

          {hasAccessCode && (
            <div className="book-access-code">
              {i18n.t("eresources.access-code")}:{" "}
              {accessCode && accessCode.revealed ? (
                accessCode.accessCode
              ) : (
                <span onClick={() => this._revealAccessCode()}>
                  {i18n.t("eresources.click-to-reveal")}
                </span>
              )}
            </div>
          )}
        </div>
        <div className="book-buttons">
          {this.props.badgeData.assignments.length > 0 && (
            <button
              className="submit"
              onClick={() => {
                this._toggleSlideout("assignments");
              }}
            >
              {$(".card").outerWidth() > 200
                ? i18n.t("library.view-assignments")
                : i18n.t("library.view-assignments")}
            </button>
          )}
          {this.props.badgeData.ancillaries &&
            (this.props.badgeData.ancillaries.ancillariesCount > 0 ||
              this.props.badgeData.ancillaries.accessCodeCount > 0) && (
              <button
                className="submit"
                onClick={() => {
                  this._toggleSlideout("resources");
                }}
              >
                {$(".card").outerWidth() > 200
                  ? i18n.t("library.view-resources")
                  : i18n.t("library.resources")}
              </button>
            )}
          <button className="noButton copy-link" onClick={this._clickCopyURL}>
            <Isvg src="/img/copy_link_small.svg" />
            <div>{i18n.t("eresources.copy-url")}</div>
          </button>
        </div>
        <ul className="book-bottom">
          {this.renderHighlightsListItem()}
          {this.renderNoteListItem()}
          {this.renderFlashCardListItem()}
          <li>
            <button
              className="book-flip-button noButton"
              onClick={this.toggleBookFlipState}
            >
              <Isvg src={"/img/arrow-curved-left.svg"} />
              <span className="screenHidden">
                {i18n.t("library.book.flip-card-title")}
              </span>
            </button>
          </li>
        </ul>
      </span>
    );

    return this.renderCard(cardTemplate, "back");
  }

  renderBookFront() {
    const ignoredTypes = this.props.unavailableTypes;
    const isUnavailable =
      ignoredTypes && ignoredTypes.indexOf(this.props.vbkType) !== -1;
    const url = `#/books/${this.props.isbn}/${
      this.props.openAssignmentCreator ? "assignment/new" : "recent"
    }`;
    var coverHolderStyle = {};
    if (this.props.view === "grid") {
      coverHolderStyle.height = this.state.coverHolderHeight;
    }
    var edition =
      this.props.edition > 1 ? (
        <div className="edition">
          {i18n.t("library.book.edition", {
            edition: numeral(this.props.edition).format("0o")
          })}
        </div>
      ) : (
        ""
      );

    var allBookAssignments = {
      html: (
        <button
          key={this.props.isbn + "book-menu-assignments"}
          className="more-book-options noButton"
          onClick={() => {
            this._toggleSlideout("assignments");
          }}
        >
          <Isvg src={"/img/assignments_icon.svg"} />{" "}
          {i18n.t("library.assignments")}
        </button>
      )
    };
    var allBookResources = {
      html: (
        <button
          key={this.props.isbn + "book-menu-resources"}
          className="more-book-options noButton"
          onClick={() => {
            this._toggleSlideout("resources");
          }}
        >
          <Isvg src={"/img/resources_icon.svg"} /> {i18n.t("library.resources")}
        </button>
      )
    };

    var menuItems = [
      {
        html: (
          <button
            key={this.props.isbn + "book-info-menu"}
            className="more-book-options noButton"
            onClick={() => {
              this._toggleSlideout("book-information");
            }}
          >
            <Isvg src={"/img/info.svg"} /> {i18n.t("library.book-information")}
          </button>
        )
      }
    ];

    if (
      this.props.badgeData.assignments &&
      this.props.badgeData.assignments.length > 0
    ) {
      menuItems.push(allBookAssignments);
    }

    if (this.props.badgeData.ancillaries) {
      menuItems.push(allBookResources);
    }
    menuItems.push({
      html: (
        <button
          key={this.props.isbn + "book-copy-url"}
          className="more-book-options noButton"
          onClick={() => {
            this._toggleSlideout("copy-link");
          }}
        >
          <Isvg id="copy-from-menu" src={"/img/copy_link_small.svg"} />{" "}
          {i18n.t("assignments.copy-link")}
        </button>
      )
    });

    const coverURL = LibraryStore.get().coverURL;
    const decodedTitle = this.props.title.decodeHTML();

    const cardTemplate = (
      <span>
        {this.props.hasAccessCode && <div className="dog-ear" />}
        <a
          className={`${isUnavailable ? "blocked" : ""}`}
          href={`${isUnavailable ? "#" : url}`}
          aria-labelledby={"title-" + this.props.isbn}
          onClick={() => {
            !isUnavailable && this._clickBook();
          }}
        >
          {isUnavailable && <div className="unavailable-shadow" />}
          {isUnavailable && (
            <div className="unavailable-message">
              {this.props.unavailableMessage}
            </div>
          )}
          <div
            className="cover-holder"
            style={coverHolderStyle}
            ref={this.coverHolderRef}
          >
            <img
              src={coverURL
                .split(":width")
                .join("200")
                .split(":isbn")
                .join(this.props.isbn)}
              role="presentation"
              className="cover"
              onLoad={this._updateCover}
              ref={this.coverImageRef}
              alt=""
            />
          </div>
          <div className="primary" ref={this.primarycontRef}>
            <div
              id={"title-" + this.props.isbn}
              className="title"
              title={decodedTitle}
              ref={this.titleRef}
            >
              <Truncate>{decodedTitle}</Truncate>
            </div>
            <div
              className="author"
              title={this.props.author.decodeHTML()}
              ref={this.authorRef}
            >
              <Truncate>{this.props.author.decodeHTML()}</Truncate>
            </div>
            <div className="isbn">ISBN: {this.props.isbn}</div>
          </div>
        </a>
        {!this.props.openAssignmentCreator &&
          this.props.view === "list" &&
          this.renderListBadges()}
        {this.renderMobileOptionsMenu()}
        {!this.props.openAssignmentCreator &&
          this.props.view === "grid" &&
          this.renderGridBadges()}
        <Menu
          menuId={"book-info-dropdown" + this.props.isbn}
          direction="up"
          key={"book-info-dropdown-" + this.props.isbn}
          xOffset={72}
          yOffset={2}
          scrollElementId="book-list"
        >
          <MenuList
            key={"book-citation-copy-menu-list-" + this.props.isbn}
            items={menuItems}
          />
        </Menu>
      </span>
    );
    return this.renderCard(cardTemplate, "front");
  }

  renderLoaderCard() {
    return (
      <li className="card" style={{ minHeight: this.state.listViewCardHeight }}>
        <div className="cover-holder" ref={this.coverHolderRef}>
          <img
            src={"/img/loader.gif"}
            alt=""
            className="cover"
            onLoad={this._updateCover}
            ref={this.coverImageRef}
          />
        </div>
        <div className="primary" ref={this.primarycontRef}>
          <div className="title" ref={this.titleRef} />
          <div className="author" ref={this.authorRef} />
        </div>
        <ul
          className="secondary"
          style={{ minHeight: this.state.listViewSecondaryHeight }}
        >
          <li>
            <div className="key">{i18n.t("library.book.vbid")}</div>
            <div className="value vbid">{this.props.isbn}</div>
          </li>
        </ul>
      </li>
    );
  }

  render() {
    // The cover image and text should be within a single anchor tag
    // No alt text needed on cover image because the screen reader will read the
    // book title below anyway
    // http://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/H2
    if (this.props.loader) {
      return this.renderLoaderCard();
    } else if (this.state.isFlipped) {
      return this.renderBookBack();
    } else {
      return this.renderBookFront();
    }
  }
}

module.exports = BookContainer;
